"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EscortAdventureHandler = void 0;
const __1 = require("../..");
const core_1 = require("../../core/events/core");
const EventType_1 = require("../../core/events/EventType");
const RoomArgs_1 = require("../../core/rooms/RoomArgs");
const RoomScript_1 = require("../../core/rooms/RoomScript");
const Schedule_1 = require("../../core/Schedule");
const Registries_1 = require("../../core/state/Registries");
const Random_1 = require("../../utils/Random");
let EscortAdventureHandler = class EscortAdventureHandler {
    init(sequence, container, state) {
        container.registerEventHandler(state.id, EventType_1.EventType.RoomCleared, Schedule_1.Schedule.Unlimited, new __1.TriggerAdventureEventHandlerArgs());
        container.registerEventHandler(state.id, EventType_1.EventType.RoomFailed, Schedule_1.Schedule.Unlimited, new __1.TriggerAdventureEventHandlerArgs());
        state.meta.roomIndex = 0;
        const options = this.selectRoomOptions(state);
        const roomId = container.addRoom(sequence, this.mkRoom(options));
        state.meta.toEscortIds = state.args.toEscort
            .map(args => container.addActor(sequence, args, true));
        container.dispatch(sequence, state.id, new __1.EnterRoomActionArgs(roomId));
        container.emitEvent(sequence, 0, new core_1.AdventureMetaUpdatedEventArgs(state.meta));
    }
    handleEvent(sequence, container, state, e) {
        switch (e.args.__typeName) {
            case "RoomCleared": {
                state.meta.roomIndex += 1;
                if (state.meta.roomIndex >= state.args.rooms.length) {
                    container.completeAdventure(sequence);
                    return;
                }
                const options = this.selectRoomOptions(state);
                const roomId = container.addRoom(sequence, this.mkRoom(options));
                container.dispatch(sequence, state.id, new __1.EnterRoomActionArgs(roomId));
                container.emitEvent(sequence, 0, new core_1.AdventureMetaUpdatedEventArgs(state.meta));
                break;
            }
            case "RoomFailed": {
                container.failAdventure(sequence);
                break;
            }
            default:
                break;
        }
    }
    tick(sequence, container, state) {
        sequence = sequence.pushSequence("sequential");
        const pass = state.meta.toEscortIds.filter(id => container.isDeceased(id));
        if (pass.length === 0) {
            return;
        }
        container.failAdventure(sequence);
    }
    selectRoomOptions(state) {
        return state.args.rooms[state.meta.roomIndex];
    }
    mkRoom(options) {
        const count = (0, Random_1.random)(options.minEnemies, options.maxEnemies);
        const actors = [
            ...options.toSpawn.slice(),
            ...Array(options.randomSpawns.length > 0 ? count : 0).fill(0).map(() => (0, Random_1.randomElement)(options.randomSpawns))
        ];
        const room = new RoomArgs_1.RoomArgs([
            new RoomScript_1.BoundRoomScript("OnEnter_SpawnActors", {
                actors
            })
        ], [], [
            new RoomScript_1.BoundRoomScript("OnTick_ClearRoom_WhenEnemiesDefeated", {}),
            new RoomScript_1.BoundRoomScript("OnTick_FailRoom_WhenAlliesDefeated", {}),
        ], options.background);
        return room;
    }
};
EscortAdventureHandler = __decorate([
    Registries_1.AdventureHandlers.register("Escort")
], EscortAdventureHandler);
exports.EscortAdventureHandler = EscortAdventureHandler;
